// extracted by mini-css-extract-plugin
module.exports = {"firstletter":"Account_firstletter__365qF"};